import { toast } from 'react-toastify';
import { createSelector } from 'reselect';
import * as XLSX from 'xlsx';
import theme from '../theme';

const fAlertToast = (xIsSuccess, xMessageOrError) => {
  let message = '';

  if (typeof xMessageOrError === 'string') {
    message = xMessageOrError;
  } else if (xMessageOrError?.response?.data?.message) {
    message = xMessageOrError.response.data.message;
  } else if (xMessageOrError?.data?.message) {
    message = xMessageOrError.data.message;
  } else if (xMessageOrError?.response?.error) {
    message = xMessageOrError.response.error;
  } else if (xMessageOrError?.error) {
    message = xMessageOrError.error;
  } else if (xMessageOrError?.message) {
    message = xMessageOrError.message;
  } else {
    message = 'An unexpected error occurred';
  }

  const vToasterStyle = {
    position: 'top-right',
    autoClose: xIsSuccess === 'SUCCESS' ? 5000 : 8000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: 'light'
  };

  switch (xIsSuccess) {
    case 'SUCCESS':
      return toast.success(message, vToasterStyle);
    case 'FAILED':
      return toast.error(message, vToasterStyle);
    case 'WARNING':
      return toast.warning(message, vToasterStyle);
    case 'INFO':
      return toast.info(message, vToasterStyle);
    default:
      return toast.info(message, vToasterStyle);
  }
};

export { fAlertToast };

export const getZoneColor = (percentage) => {
  if (percentage < 50) return 'Green';
  if (percentage < 75) return 'Yellow';
  if (percentage < 90) return 'Orange';
  return 'Red';
};

export const exportToExcel = (data, fileName = 'data', sheetName = 'Sheet1') => {
  const workSheet = XLSX.utils.json_to_sheet(data);
  const workBook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workBook, workSheet, sheetName);
  XLSX.writeFile(workBook, `${fileName}.xlsx`);
};

//userSlice
export const userSelector = (state) => state.user;
export const userLoginReselect = createSelector([userSelector], (user) => user);
export const departmentTypeReselect = createSelector([userSelector], (user) => user.depts);
export const usersArrReselect = createSelector([userSelector], (user) => user.users);
export const projectArrReselect = createSelector([userSelector], (user) => user.project);
export const modelesArrReselect = createSelector([userSelector], (user) => user.modelesArr);
export const locationReselect = createSelector([userSelector], (user) => user.LocationDetail);
export const redZonesReselect = createSelector([userSelector], (user) => user.redZones);

//leadSlice
export const leadSelector = (state) => state.lead;
export const leadSummaryReselect = createSelector([leadSelector], (lead) => lead.summaryObj);
export const leadSummaryGridReselect = createSelector(
  [leadSelector],
  (lead) => lead.summaryGridData
);
export const leadStagesReselect = createSelector(
  [leadSelector],
  (lead) => lead.leadStagesSummaryData
);
export const stagesSummaryReselect = createSelector(
  [leadSelector],
  (lead) => lead.stagesSummaryObj
);

// Utility function to handle Enter key press for input fields
const fKeyTabInput = (event, name) => {
  if (event.key === 'Enter') {
    document?.getElementsByName(name)[0]?.focus();
  }
};
const fKeyTabEnterInput = (event, id) => {
  if (event.key === 'Enter') {
    document?.getElementById(id)?.focus();
  }
};

const focusOnEnterInLoop = (e, nextFieldId) => {
  if (e.key === 'Enter') {
    e.preventDefault();
    const el = document.getElementById(nextFieldId);
    if (el) el.focus();
  }
};

const formatPrice = (num) =>
  Number(num).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

const formatNumeric = (num) =>
  Number(num).toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 });

const fContent_Focus = (e, setState) => {
  if (e.target.value === '0.00' || e.target.value === '0') {
    setState((prev) => ({
      ...prev,
      [e.target.name]: ''
    }));
  }
};

const fContent_Blur = (e, setState) => {
  if (e.target.value === '') {
    setState((prev) => ({
      ...prev,
      [e.target.name]: (0).toFixed(2)
    }));
  }
};

const getStatusStyle = (status) => {
  switch (status) {
    case 'Low':
      case 'Test1':
      return { color: theme.palette.statusClr.low, fontWeight: 'bold' };
    case 'Medium':
      case 'Test2':
      return { color: theme.palette.statusClr.medium, fontWeight: 'bold' }; 
    case 'High':
      return { color: theme.palette.statusClr.high, fontWeight: 'bold' }; 
    default:
      return { color: theme.palette.statusClr.critical, fontWeight: 'bold' };
  }
};

const simulateProgress = (setValue, onComplete) => {
  let value = 0;
  const interval = setInterval(() => {
    value += Math.floor(Math.random() * 10) + 5;
    if (value >= 90) {
      clearInterval(interval);
      onComplete(); // when real download completes
    } else {
      setValue(value);
    }
  }, 100);
};

const calculateTaxDetails = (taxableAmount, taxPerc) => {
  const parsedAmount = parseFloat(taxableAmount) || 0;
  const parsedTaxPerc = parseFloat(taxPerc) || 0;

  const taxAmount = (parsedAmount * parsedTaxPerc) / 100;
  const netAmount = parsedAmount + taxAmount;

  return {
    TaxAmount: taxAmount.toFixed(2),
    NetAmount: netAmount.toFixed(2)
  };
};

export {
  fKeyTabInput,
  fKeyTabEnterInput,
  focusOnEnterInLoop,
  formatPrice,
  formatNumeric,
  fContent_Focus,
  fContent_Blur,
  getStatusStyle,
  simulateProgress,
  calculateTaxDetails
};
